<template>
	<v-container class="pt-0">
		<v-row no-gutters>
			<v-col>
				<v-card class="elevation-1 justify-center text-center" color="white">
					<v-card-title @click="cancelLocumSearch()">
						<v-btn text class="secondary--text font-weight-bold"> <v-icon large color="secondary" @click="cancelLocumSearch()">keyboard_backspace</v-icon>Back </v-btn>
						<v-spacer></v-spacer>
					</v-card-title>
					<v-divider></v-divider>
					<v-card-text>
						<!--the card -->
						<v-row readonly flat>
							<v-col>
								<v-list-item>
									<v-list-item-content align="center" justify="center">
										<v-list-item-title
											class="title font-weight-black"
											v-text="getLabel('bookingFlowBookingSummaryTitle', 'Booking Summary')"
										></v-list-item-title>
									</v-list-item-content>
								</v-list-item>
							</v-col>
						</v-row>
						<!--end card -->
					</v-card-text>
					<v-divider></v-divider>
					<v-card-text>
						<!--the card -->
						<v-row readonly flat>
							<v-col>
								<v-list-item style="font-family: Montserrat;font-style: normal;font-weight: normal;font-size: 16px;line-height: 20px; !important">
									Perform a new search with these remainder days :
								</v-list-item>
							</v-col>
						</v-row>
						<!--end card -->
					</v-card-text>
					<v-card-text class="pt-0 mt-0">
						<!--the card -->
						<v-row no-gutters align="center" justify="center">
							<v-col v-for="(day, index) in this.summaryDays" :key="'card-' + index" :cols="4" align="center" justify="center">
								<v-card elevation="0" class="pt-2 ma-1" height="72px" align="center" justify="center">
									<CalendarDateIcon :date="day" color="green"></CalendarDateIcon>
								</v-card>
							</v-col>
						</v-row>
						<!--end card -->
					</v-card-text>
					<v-divider></v-divider>
					<v-card-actions>
						<v-row>
							<v-col>
								<v-btn outlined style="background: #ffffff; border: 1px solid primary; box-sizing: border-box; border-radius: 100px" @click="cancelLocumSearch()"
									><div
										style="
											font-family: Montserrat;
											font-style: normal;
											font-weight: bold;
											font-size: 16px;
											line-height: 20px;
											text-align: center;
											color: var(--v-primary-base);
										"
									>
										Not Now
									</div></v-btn
								>
							</v-col>
						</v-row>
						<v-row>
							<v-col>
								<v-btn style="background: var(--v-primary-base); box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05); border-radius: 100px" @click="performNewSearch"
									><div
										style="
											font-family: Montserrat;
											font-style: normal;
											font-weight: bold;
											font-size: 16px;
											line-height: 20px;
											text-align: center;
											color: #ffffff;
										"
									>
										Yes, Continue
									</div></v-btn
								>
							</v-col>
						</v-row>
					</v-card-actions>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import store from '@/store';
import CalendarDateIcon from '@/components/custom/CalendarDateIcon.vue';

/* eslint-disable  */
import axios from 'axios';
import moment from 'moment';
import { bus } from '@/main';
/* eslint-enable  */

export default {
	name: 'PracticeToLocumBookingSummary',
	components: { CalendarDateIcon },
	data: () => ({
		items: {},
		keyboi: 0,

		buttonColor: 'red',

		trackedDates: {},

		apiRequest: false,
		API_URL: store.getters.getAPI,
		//
		locums: [
			{
				avatar: 'https://cdn.vuetifyjs.com/images/lists/3.jpg',
				name: 'Jane Doe',
				profession: 'Dentist',
				datetime: '9:00AM -> 11:00PM (2 Hours)',
				location: '',
				university: '',
				bio: 'Lorem Ipsum Lorem Ipsum',
				rating: 4.5,
			},
		],

		//time pickers
		//starttime: JSON.stringify(store.getters.getPracticeOffer.start_time),
		//endtime: JSON.stringify(this.theOffer.end_time),

		starttime: '',
		endtime: '',

		starttimemodal: false,
		endtimemodal: false,

		switch1: false,
		switch2: false,
		switch3: false,

		notes: '',

		//lunch

		/** 
    haslunchbreak: store.getters.getPracticeOffer.lunch.allowed,
    hashourlunch: this.theOffer.lunch.period > 0 ? true : false,
    haspaidlunch: this.theOffer.lunch.paid,
    hashalfhourlunch: this.theOffer.lunch.period < 1 ? true : false,

    **/

		hashourlunch: null,
	}),
	computed: {
		locum() {
			return store.getters.getPracticeLocumSearchResults[store.getters.getPracticeViewingLocum][0];
		},
		summaryDays() {
			return store.getters.getPracticeOffer.available_dates;
		},
		theOffer() {
			return store.getters.getPracticeOffer;
		},
		companyAddressAsString() {
			let result = '';
			Object.keys(store.getters.company.address).forEach(key => {
				if (key != 'update_timestamp') {
					result += store.getters.company.address[key] + ', ';
				}
			});
			return result;
		},
	},
	created() {},
	mounted() {
		if (this.summaryDays.length == 0) {
			this.cancelLocumSearch();
		}
	},
	methods: {
		viewLocumProfile() {
			bus.$emit('change-context', 'practice-locum-profile');
		},

		cancelLocumSearch() {
			bus.$emit('change-context', 'practice-dashboard-landing-zone');
		},
		async performNewSearch() {
			this.apiRequest = true;
			let available_dates = store.getters.getPracticeOffer.available_dates.sort((a, b) => moment(a).diff(moment(b)));
			let startdate = available_dates[0];
			let enddate = available_dates[available_dates.length - 1];
			const { profession, languages, company, rates, experience } = this.theOffer;
			await store.dispatch('PERFORM_LOCUM_SEARCH', {
				profession,
				segments: [[startdate, enddate]],
				languages,
				location: `${company.address.province},${company.address.region}`,
				rates,
				experience,
				dates: available_dates,
			});
			this.apiRequest = false;

			bus.$emit('change-context', 'practice-locum-search-results');
		},

		colorOfIndex(index) {
			if (!(index in this.trackedDates)) {
				this.trackedDates[index] = false;
			}
			return this.trackedDates[index] ? 'green' : 'red';
		},
		OnClick(index) {
			this.keyboi += 1;

			if (!(index in this.trackedDates)) {
				this.trackedDates[index] = true;
			} else {
				this.trackedDates[index] = !this.trackedDates[index];
			}
		},
	},
};
</script>
